import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_ViewSection {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadSemesters(SchoolID) {
		var postResult$ = new Subject();
		var url = "Section/LoadSemesters?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSection(SemesterID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Section/LoadSection?SemesterID=" + SemesterID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSectionDetails(SectionID, SemesterID) {
		var postResult$ = new Subject();
		var url = "Section/LoadSectionDetails?SectionID=" + SectionID + "&SemesterID=" + SemesterID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadStudents(SectionID) {
		var postResult$ = new Subject();
		var url = "Section/LoadStudents?SectionID=" + SectionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
